import React, { ReactElement } from "react";
import { Stack, Text } from "sprint-common-web";

import { ShreqContentReferenceResponse } from "../../../common/api/catalogue-api/movie/MovieDocumentResponse";

export const renderShreqItem = (props: ShreqContentReferenceResponse | undefined): ReactElement | null => {
    if (!props) {
        return null;
    }

    return (
        <Stack>
            <Stack verticalAlign="center">
                <Text value={`Id: ${props.id}`} styles={{ root: { fontSize: 12 } }} />
            </Stack>
        </Stack>
    );
};
